export default {
  noLikesFound: '未找到赞',
  noMusicalGenresFound: '还没有音乐流派',
  noArtistsFound: '还没有艺术家',
  noSongsFound: '还没有歌曲',
  extraData: '其他信息',
  noExtraDataFound: '没有其他信息',
  typeOfRegister: '寄存器类型',
  createList: '创建列表',
  import: '进口',
  invitations: '邀请',
  invite: '邀请',
  seeGuests: '见客人',
  addNew: '添加新',
  mustChargeBeforeCreatePeople: '在创建人员之前，你必须收钱',
  invited: '邀请',
  verified: '验证',
  notVerified: '未验证',
  imported: '进口',
  notImported: '未导入',
  oneTimePassword: '一次性密码',
  changePassword: '更改密码',
  deletePerson: '删除人员',
  loading: '加载',
  noPeopleRegistered: '没有登记的人',
  emailOrPhone: '电子邮件或电话',
  method: '方法',
  creationDate: '创建日期',
  actions: '行动',
  customizedSearch: '自定义搜索',
  state: '状态',
  createPerson: '创建人员',
  perPage: '每页',
  loadFile: '加载文件',
  organizeData: '组织数据',
  verify: '验证',
  pickToImportBusinessesOrPeopleToNewList: '选取是否要将企业或人员导入新或现有列表',
  pickToSavePeopleToList: '如果要将导入的人保存到列表中，选择',
  business: '业务',
  existentList: '存在列表',
  newList: '新列表',
  noList: '无列表',
  listsNotCreated: '您尚未创建任何列表',
  pickAList: '选择列表',
  typeNameOfTheList: '键入列表名称',
  uploadFileTypeInfo: '上传以 CSV 或 xlsx 格式保存联系人的文件',
  pickFile: '选取文件',
  identifyImportedFields: '根据要包含的信息中标识每个字段',
  newColumnName: '新列名称',
  verifyInfoBeforeListCreation: '在创建列表之前验证信息是否正确',
  cancel: '取消',
  goBack: '回去',
  continue: '继续',
  message: '消息',
  other: '其他',
  contact: '联系',
  company: '公司',
  address: '地址',
  document: '文档',
  image: '图像',
  location: '位置',
  observation: '观察',
  position: '位置',
  phone: '电话',
  phonePaste: '粘贴电话号码',
  phoneWrite: '写上电话号码',
  validPhone: '有效的电话号码',
  invalidPhone: '无效电话',
  switchPasteModePhone: '切换到粘贴模式的手机输入',
  switchWriteModePhone: '切换到写入模式的手机输入',
  pickWhereToSavePeopleToImport: '选择将要导入的人保存到何处',
  pleaseAddAValidFile: '请添加有效的文件',
  errorReadingTheFile: '读取文件时出错',
  newPerson: '新人',
  password: '密码',
  addNewPerson: '添加新人员',
  personSuccessfullyAdded: '已成功添加的人员',
  sendEmailTo: '发送电子邮件至',
  sendSMSTo: '发送短信到',
  call: '叫',
  downloadContact: '下载联系人',
  editUser: '编辑用户',
  know: '知道',
  connect: '连接',
  emailVerify: '电子邮件验证',
  talk: '说话',
  tasks: '任务',
  record: '行动',
  addPersonEmailOrPhoneToNotifyAboutTaskStatus: '添加人员电子邮件或电话以发送有关任务状态的通知',
  observations: '观察',
  editTask: '编辑任务',
  youMustAddTheNameOfTheTask: '必须添加任务的名称',
  sameNameTask: '已存在具有此名称的任务',
  taskSuccessfullyDeleted: '已成功删除任务',
  noPersonNotes: '此用户没有保存的笔记',
  insertNewNote: '插入新注释',
  currentNotes: '保存的笔记',
  editNote: '编辑此注释',
  deleteNote: '删除此注释',
  errorUpdatingNotes: '无法更新注释',
  clickPendingTasks: '单击以查看任务详细信息',
  tasksList: '任务列表',
  tasksDueToday: '今天到期',
  tasksDueAfter: '到期后',
  tasksDueBefore: '到期前',
  daysRemaining: '剩余天数',
  extraManagementAddNewField: '添加新的信息字段',
  extraManagementAditionalInfo: '来自您品牌人士的其他信息',
  extraManagementItemAccessApplication: '只能由此应用程序的管理员看到',
  extraManagementItemAccessPerson: '可以看到的人',
  extraCreatorShortText: '短文本字段',
  extraCreatorLongText: '大文本字段',
  extraCreatorList: '下拉列表',
  extraCreatorRadioList: '单选按钮列表',
  extraCreatorCheckList: '复选框列表',
  extraCreatorEmail: '电子邮件',
  extraCreatorCreateField: '创建一个广告信息字段',
  extraCreatorEditField: '编辑广告信息字段',
  extraCreatorFieldName: '字段的名称',
  extraCreatorFieldType: '字段的类型',
  extraCreatorFieldAccess: '进入现场',
  extraCreatorAddOptions: '添加选项',
  extraCreatorOption: '选项',
  extraCreatorApplication: '应用',
  extraCreatorApplicationInfo: '允许应用程序从管理员处可视化和修改此字段',
  extraCreatorPersonInfo: '允许用户从配置文件中可视化和修改此字段',
  extraCreatorAddTags: '添加一些標籤',
  extraCreatorMessageEnterTag1: '沒有匹配的結果',
  extraCreatorMessageEnterTag2: '按',
  extraCreatorMessageEnterTag3: '創造一個新的',
  setResponsible: '设置一个负责任的',
  assign: '分配',
  selectResponsible: '选择负责这个新用户列表',
  pickAResponsible: '选择一个负责任的',
  selectResponsibleSolo: '选择该用户的负责人',
  seeLess: '查看更少',
  favoriteSongs: '最喜欢的歌曲',
  favoriteMusicalGenres: '最喜欢的音乐流派',
  favoriteArtists: '最喜欢的艺术家',
  noInstagramSpotifyTags: '还没有 Instagram 或 Spotify 首选项',
  addToList: '添加到列表',
  noPersonRecords: '此用户没有操作记录',
  personAddedToList: '添加到列表的人员',
  messageSuccessfullySent: '已成功发送消息',
  loadCsv: '加载 CSV',
  insertInvitedPeopleEmailPhone: '插入要邀请的人的所有电子邮件或电话，通过逗号分隔',
  noEmail: '无电子邮件',
  noPhone: '无电话',
  noLoadedInvitations: '未加载邀请',
  downloadCsv: '下载 CSV',
  invitePerson: '邀请人',
  inviteAdministrator: '邀请管理员',
  invitedPeople: '被邀请的人',
  sendSms: '发送短信',
  resendInvitations: '重新发送邀请',
  noInvitationsSent: '未发送邀请',
  noAssistantSelected: '您尚未选择任何助手',
  thisEmailIsGoingToBeSentTo: '此电子邮件将发送到',
  assistants: '助理',
  noPersonSelected: '您尚未选择任何人',
  allTheEventAssistants: '所有 [事件] 助手',
  close: '关闭',
  send: '发送',
  accept: '接受',
  actualPassword: '实际密码',
  change: '改变',
  youAreAboutToChangeUserPassword: '您即将更改 [用户] 的密码，请记住告诉此人新密码',
  saveChanges: '保存更改',
  onetimePasswordUse: '此密码只能使用一次',
  sendToPersonEmail: '发送到人的电子邮件',
  sendToPersonPhone: '发送到人的电话',
  generatePassword: '生成密码',
  passwordCopiedToClipboard: '密码已复制到剪贴板',
  errorCopyingThePassword: '复制密码错误',
  doYouWantToDeleteThisPerson: '是否要删除此人？',
  personSuccessfullyDeleted: '已成功删除的人员',
  selectFinishingDate: '选择修整日期',
  pick: '选择',
  selectFinishingHour: '选择精加工小时',
  createTask: '創建任務',
  currentTasks: '当前任务',
  noTasksToDo: '没有任务要执行',
  hour: '小时',
  date: '日期',
  moveToDoneTasks: '移动到已完成的任务',
  deleteTask: '删除任务',
  completedTasks: '已完成的任务',
  noCompletedTasks: '没有完成的任务',
  moveToUndoneTasks: '移动到撤消的任务',
  errorUpdatingTasks: '无法更新任务',
  enterTheNameAndDescriptionOfTheTask: '輸入任務的名稱和觀察結果',
  insertANewTask: '插入新任务',
  editProfile: '编辑配置文件',
  insertFullName: '插入您的全名',
  insertYourEmail: '插入您的电子邮件',
  addRoles: '添加角色',
  description: '描述',
  userDescription: '用户描述',
  notes: '笔记',
  addCommentsAboutThisPerson: '添加此人的评论',
  noInformation: '无信息',
  updatedCorrectly: '正确更新',
  searchCountry: '搜索国家/地区',
  countryNotFound: '未找到国家/地区',
  uploadDocument: '上传文档',
  downloadDocument: '下载文档',
  editDocument: '编辑文档',
  deleteDocument: '删除文档',
  documents: '文件',
  deleteDocumentConfirmation: '是否确实要删除此文档？',
  insertDocumentDescription: '输入文档说明',
  editDescription: '编辑说明',
  documentSuccessfullyDeleted: '已成功删除文档',
  youMustPickADocumentToEdit: '您必须选择要编辑的文档',
  fileSizeMustBeUnderXSize: '附加的文件大小必须低于 [大小]',
  documentSuccessfullyEdited: '已成功删除文档',
  documentSuccessfullyUploaded: '已成功上载文档',
  editList: '编辑列表',
  listCorrectlyUpdated: '列表已正确更新',
  personDeletedFromList: '从列表中删除的人员',
  doYouWantToDeleteThisList: '是否要删除此列表',
  deleteList: '删除列表',
  listDeleted: '已删除的列表',
  lists: '列表',
  create: '创建',
  campaign: '运动',
  peopleLists: '人员列表',
  peopleListsNotCreated: '您尚未创建任何人员列表',
  peopleInTheList: '列表中的人',
  listName: '列表名称',
  waitUntilTheListGetsCreated: '等待列表创建',
  loadingPeopleFromTheList: '从列表中加载人员',
  noPeopleInThisList: '此列表中没有人员',
  rolesNotCreated: '没有创建的角色',
  code: '代码',
  nameOfTheRol: 'rol 的名称',
  newRol: '新罗尔',
  addNewRol: '添加新的 rol',
  rolSuccessfullyCreated: '罗尔已成功创建',
  editRol: '编辑罗尔',
  rolSuccessfullyEdited: '罗尔已成功编辑',
  columnsTable: '列',
  edit: '編輯',
  loadingPerson: '裝貨人',
  weCouldNotFindThisPerson: '我們找不到這個人',
  youMustAddKeyToUpdateUser: '您應該添加一個密鑰來更新此人',
  noDocumentsWereFoundForThisPerson: '沒有與此人相關的上傳文檔',
  email: '電子郵件',
  verifyEmail: '驗證郵件',
  roles: '的角色',
  updateAppPublicKey: '更新應用公鑰',
  emailSuccessfullyVerified: '電子郵件已成功驗證',
  closeProfile: '關閉個人資料',
  journey: '旅程',
  noJourneyForCurrentApp: '您的應用沒有關聯的旅程，請創建一個旅程以添加或更改此人的當前旅程狀態',
  changeJourneyCurrentStatus: '更改此人的旅程當前狀態',
  dependsOn: '依賴於取決於',
  isDependencyOf: '是依賴',
  changeJourneyCurrentStatusWarning: '您確定要更改此人的旅程的當前狀態嗎？',
  changeJourneyStatus: '更改旅程當前狀態',
  customFields: '自定義字段',
  seeFilters: '查看過濾器',
  hideFilters: '隱藏篩選器',
  peopleFilters: '人民過濾器',
  clearFields: '清除欄位',
  startEditingMode: '開始編輯模式',
  stopEditingMode: '停止編輯模式',
  createNewTaskToAssignInBlock: '創建要在塊中分配的新任務',
  taskCreatedSuccessfully: '任務創建成功',
  chooseTheTypeOfBlockEdition: '首先選擇要開始該過程的塊編輯類型',
  modifyTheAdditionalDataThatYouWant: '修改所需的其他數據',
  justTheFilledExtraDataAreGoingToBeChanged: '只有填充了一些信息的多餘數據才會被編輯，其餘的將被忽略',
  pickTheJourneyStatusToAssignInBlock: '選擇一個旅程狀態以在塊中分配',
  editInBlock: '塊編輯',
  enterInformation: '輸入信息',
  modifyAtLeastOneExtraDataToEditInBlock: '您必須至少修改一個額外的數據才能進行塊編輯',
  addAJourneyStatusToEditInBlock: '您必須添加旅途狀態才能在塊中對其進行編輯',
  createAValidTaskToAddInBlock: '您必須創建一個有效任務才能將其添加到塊中',
  editPeopleInBlock: '修改人',
  aListWithThisNameAlreadyExists: '此名稱的列表已存在',
  addTheNameOfTheListToBeCreated: '添加要創建的列表的名稱',
  changeExtraData: '更改其他信息',
  pickAtLeastOneTypeOfEditingToEditInBlock: '您必須至少選擇一種編輯類型並填寫相應的信息',
  editInBlockFinishedSuccessfully: '在塊中編輯成功完成',
  youMustAddTagsInOrderToFilterExtraData: '您必須將標籤添加到其他數據中才能按標籤過濾',
  menu: '菜單',
  of: '的',
  responsible: '負責任的',
  addPersonToBusiness: '新增人員',
  businessSuccessfullyAdded: '業務已成功添加',
  enterPersonPositionInBusiness: '輸入人員的業務位置',
  searchABusinessToAdd: '搜索商家以添加',
  thisPersonHasNoBusinesses: '此人沒有相關的業務',
  fullName: '全名',
  firstName: '名字',
  onlyStaticListsAreListedBelow: '下面僅列出靜態列表',
  listType: '清單類型',
  static: '靜態的',
  dynamic: '動態',
  mainPhone: '主電話',
  profile: '個人資料',
  orderExtraData: '訂購額外數據',
  tags: '標籤',
  noTags: '沒有標籤',
  privacyTermsWarning: '導出數據不是一個好習慣，因為它可能違反1581年法律和GDPR。您確定要導出數據嗎？',
  registerName: '注册名称？',
  sendEmail: '發電子郵件',
  editResponsible: '编辑负责',
  permissionsFor: '的权限',
  // Importing people info
  numberOfRows: '行數',
  totalPeople: '總人數',
  uniquePeople: '獨特的人',
  savedPeople: '被救的人',
  updatedPeople: '更新的人',
  insertedPeople: '插入人',
  duplicatedPeople: '重複的人',
  importCompleted: '導入完成',
  importingBusinesses: '進口業務',
  creatingList: '建立清單',
  peopleRegistrationInformation: '所選期間的人員註冊信息',
  businessInformationItems: '商業信息欄',
  personalInformationItems: '個人信息欄',
  extraDataItems: '附加信息欄',
  addSelectedUsersToList: '將所選用戶添加到列表',
  usersSuccessfullyAddedToList: '用戶已成功添加到列表'
}
